module.exports = __webpack_public_path__ + "static/img/bg_3_2.0985c72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_3_2.png
// module id = Pz3y
// module chunks = 3